import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  CircularProgress,
  Box,
  Card,
  Button,
  Autocomplete,
  Paper,
  Avatar,
  AvatarGroup,
  Tooltip,
  Chip,
} from "@mui/material";
import { FieldArray, FormikProvider, useFormik } from "formik";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import {
  useAssignClassStudentMutation,
  useGetallLocationQuery,
  useGetallStudentQuery,
  useGetallSubjectQuery,
  useGetAssignClassListFilterQuery,
  useGetTeamQuery,
  useGetallAssignClassesQuery,
  useGetallGradeQuery,
} from "../../../Api/attoDeskApi";
import {
  CustomerOption,
  IClassCreate,
  IStudentLocation,
  ITeam,
  IGrade,
  ISubject,
  IStudent,
  IClassCreateList,
  ISubjectGradeAssign,
  CustomerOptionString,
} from "../../../Api/Interface/api.interface";
import { ClassType, TeachMood, WeekDays } from "../../../Core/Enum/enum";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import dayjs from "dayjs";
import { Link, useNavigate, useParams } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../Components/Validation/capitalizeFirstLetter";
import GroupIcon from "@mui/icons-material/Group";
import PlaceIcon from "@mui/icons-material/Place";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import LoadingPage from "../../../Components/LoadingDialog/LoadingPage";

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);
const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const studyMoodTecher = (unit: string) => {
  switch (unit) {
    case TeachMood.Online:
      return "Online";
    case TeachMood.Offline:
      return "InPerson";
    
    default:
      return "";
  }
};
const Index = () => {
  const { id: studentId } = useParams<{ id: string }>();
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(currentSearchQuery, 300);
  const [getStaffID, setGetStaffId] = useState(String(studentId ?? ""));

  const [newCompany, { isLoading }] = useAssignClassStudentMutation();
  const [selectedSubject, setSelectedSubject] = useState<number[]>([]);
  const [selectedWeekDays, setSelectedWeeekDays] = useState<string[]>([]);
  const [getFilterStaffId, setFilterStaffId] = useState("");
  const [getLocationId, setLocationId] = useState("");
  const [getClassMode, setClassMood] = useState("");
  const [getClassType, setClassType] = useState("");
  const [getGradeId, setGradeId] = useState("");
  const [getSubjectId, setSubjectId] = useState("");
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);

  const [selectedAssignClasses, setSelectedAssignClasses] = useState<
    number | null
  >(null);

  const {
    data: assignClassFilterData,
    isLoading: assignClassIsLoading,
    refetch: asiignClassRefetch,
  } = useGetAssignClassListFilterQuery({
    id: "",
    staff_id: getFilterStaffId,
    location_id: getLocationId,
    class_mode: getClassMode,
    class_type: getClassType,
    select_grade_subject_ids: selectedSubject,
    selected_days: selectedWeekDays,
    grade_id: getGradeId,
    subject_id: getSubjectId,
    createdDateStart: endDate,
    createdDateEnd: startDate,
  });

  const { data: locationData, isLoading: locationIsLoading } =
    useGetallLocationQuery({
      searchText: "",
    });

  const { data: gradeData, isLoading: gradeIsLoading } = useGetallGradeQuery({
    searchText: "",
  });

  const {
    data: studentPerentData,
    isLoading: studentPerentIsLoading,
    refetch,
  } = useGetallStudentQuery({
    searchText: "",
    id: "",
  });

  const {
    data: subjectData,
    isLoading: subjectIsLoading,
    refetch: subjectRefetch,
  } = useGetallSubjectQuery({
    searchText: "",
  });

  const { data: assignClassData, isLoading: assignClassListIsLoading } =
    useGetallAssignClassesQuery({
      searchText: "",
    });

  const { data: staffData, isLoading: staffIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const studentPerentList = useMemo(() => {
    return (studentPerentData?.data ?? []) as IStudent[];
  }, [studentPerentData?.data]);

  const locationList = useMemo(() => {
    return (locationData?.data ?? []) as IStudentLocation[];
  }, [locationData?.data]);

  const subjectDataList: ISubject[] = Array.isArray(subjectData?.data)
    ? (subjectData?.data as ISubject[])
    : [];

  const gradeDataList: IGrade[] = Array.isArray(gradeData?.data)
    ? (gradeData?.data as IGrade[])
    : [];

  const assignClassDataList: IClassCreateList[] = Array.isArray(
    assignClassFilterData?.data
  )
    ? (assignClassFilterData?.data as IClassCreateList[])
    : [];

  const assignClassList = useMemo(() => {
    return (assignClassData?.data ?? []) as ISubjectGradeAssign[];
  }, [assignClassData?.data]);

  const teamList = useMemo(() => {
    return staffData?.data as ITeam[];
  }, [staffData?.data]);

  const filterStaffList = useMemo(() => {
    return assignClassFilterData?.staffData as ITeam[];
  }, [assignClassFilterData?.staffData]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const formik = useFormik<IClassCreate>({
    initialValues: {
      student_id: String(studentId),
      location_id: "",
      class_mode: "",
      class_type: "",
      number_of_student: null,
      select_grade_subject_ids: [],
      period_based_from_date: null,
      period_based_to_date: null,
      notes: "",
      selected_days: [],
      startTime: "",
      endTime: "",
      staff_id: "",
      class_id: null,
      grade_id: "",
      subject_id: "",
    },
    enableReinitialize: true,

    onSubmit: async (values, { resetForm }) => {
      try {
        const updatedData = {
          student_id: values.student_id,
          location_id: values.location_id,
          class_mode: values.class_mode,
          class_type: values.class_type,
          number_of_student: values.number_of_student,
          select_grade_subject_ids: selectedSubject,
          notes: values.notes,
          selected_days: selectedWeekDays,
          period_based_from_date: values.period_based_from_date
            ? values.period_based_from_date.format("YYYY-MM-DD")
            : null,
          period_based_to_date: values.period_based_to_date
            ? values.period_based_to_date.format("YYYY-MM-DD")
            : null,
          startTime: values.startTime,
          endTime: values.endTime,
          staff_id: values.staff_id,
          class_id: values.class_id,
          grade_id: values.grade_id,
          subject_id: values.subject_id,
        };

        const response = await newCompany(updatedData).unwrap();
        if (!response.status) {
          showErrorMessage(response.message);
        } else {
          showMessage(response.message);
          navigate(`/student-history/${studentId}`);
          resetForm();
          setSelectedSubject([]);
          setSelectedWeeekDays([]);
          setFilterStaffId("");
          setLocationId("");
          setClassMood("");
          setClassType("");
          setSelectedAssignClasses(null);
          setGradeId("");
          setSubjectId("");
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.student_id === "" ||
      formik.values.student_id === undefined ||
      formik.values.class_id === null ||
      formik.values.class_id === undefined
      ? false
      : true;
  }, [formik]);

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  const filterStaffOptions = useMemo(() => {
    if (!Array.isArray(filterStaffList)) return [];

    return filterStaffList.map((staff) => ({
      label: `${staff.teamFirstName || ""} ${staff.middle_name || ""} ${
        staff.teamLastName || ""
      }`.trim(),
      value: staff.id,
      image: staff.teamImg || null,
    }));
  }, [filterStaffList]);

  const locationOptions = useMemo(() => {
    if (!Array.isArray(locationList)) return [];
    return locationList.map((cust) => ({
      label: `${cust.location_name || cust.location_address}`,
      value: cust.id,
    }));
  }, [locationList]);

  const subjectOptions = useMemo(() => {
    if (!Array.isArray(subjectDataList)) return [];
    return subjectDataList.map((cust) => ({
      label: `${cust.subject_name}`,
      value: cust.id,
    }));
  }, [subjectDataList]);

  const gradeOptions = useMemo(() => {
    if (!Array.isArray(gradeDataList)) return [];
    return gradeDataList.map((cust) => ({
      label: `${cust.grade}`,
      value: cust.id,
    }));
  }, [gradeDataList]);

  const teamMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
        hourlySalary: string;
        otHourlySalary: string;
      }
    >();

    teamList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.teamFirstName || ""
      )} ${capitalizeFirstLetter(
        teamMember.middle_name || ""
      )} ${capitalizeFirstLetter(teamMember.teamLastName || "")}`.trim();

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.teamImg,
        hourlySalary: teamMember.teamHourlySalary,
        otHourlySalary: teamMember.teamOtHourlySalary,
      });
    });

    return map;
  }, [teamList]);

  const assignStudentMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
      }
    >();

    studentPerentList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.first_name || ""
      )} ${capitalizeFirstLetter(
        teamMember.middle_name || ""
      )} ${capitalizeFirstLetter(teamMember.last_name || "")}`.trim();

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.image,
      });
    });

    return map;
  }, [studentPerentList]);

  const locationMap = useMemo(() => {
    const map = new Map<
      number,
      {
        location_name: string;
        location_color: string;
      }
    >();

    locationList?.forEach((teamMember) => {
      map.set(teamMember.id, {
        location_name: teamMember.location_name,
        location_color: teamMember.location_color,
      });
    });

    return map;
  }, [locationList]);

  const gradeClassMap = useMemo(() => {
    const map = new Map();
    assignClassList?.forEach((category) => {
      map.set(category.id, category.grade_name);
    });
    return map;
  }, [assignClassList]);

  const assignClassMap = useMemo(() => {
    const map = new Map();
    assignClassList?.forEach((category) => {
      map.set(category.id, category.subject_name);
    });
    return map;
  }, [assignClassList]);

  const cancelFunction = () => {
    formik.resetForm();
    setSelectedSubject([]);
    setSelectedWeeekDays([]);
    setFilterStaffId("");
    setLocationId("");
    setClassMood("");
    setClassType("");
    setSelectedAssignClasses(null);
    setGradeId("");
    setSubjectId("");
  };

  const submitFunction = () => {
    formik.handleSubmit();
  };

  const handleClassSelect = (classId: number) => {
    setSelectedAssignClasses(classId);
    formik.setFieldValue("class_id", classId);
  };

  const studyMoodOptions: CustomerOptionString[] = Object.values(TeachMood).map(
    (day) => ({
      label: studyMoodTecher(day),
      value: day,
    })
  );

  const classTypeOptions: CustomerOptionString[] = Object.values(ClassType).map(
    (day) => ({
      label: day,
      value: day,
    })
  );

  const getClassScheduleSummary = (availability: any[]) => {
    const days: string[] = [];
    let startTime = "";
    let endTime = "";

    availability.forEach((day) => {
      if (day.timeSlots.length > 0) {
        days.push(day.day);

        // Take time from first available slot
        if (!startTime && !endTime) {
          startTime = day.timeSlots[0].startTime;
          endTime = day.timeSlots[0].endTime;
        }
      }
    });

    return { days, startTime, endTime };
  };

  const pageIsLoading =
    locationIsLoading ||
    studentPerentIsLoading ||
    subjectIsLoading ||
    staffIsLoading ||
    assignClassListIsLoading ||
    gradeIsLoading;

  if (pageIsLoading) {
    return <LoadingPage open={pageIsLoading} />;
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item lg={3} md={4} sm={12} xs={12}>
                <Card className={classes.card} sx={{ height: "100%" }}>
                  <Grid container spacing={2} p="24px">
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Select Grade
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Autocomplete
                        options={gradeOptions}
                        loading={gradeIsLoading}
                        getOptionLabel={(option: CustomerOption) =>
                          option.label
                        }
                        value={
                          gradeOptions.find(
                            (opt) =>
                              opt.value === Number(formik.values.grade_id)
                          ) || null
                        }
                        onChange={(_, newValue: CustomerOption | null) => {
                          const staffId = newValue?.value
                            ? String(newValue.value)
                            : "";

                          formik.setFieldValue("grade_id", staffId);
                          setGradeId(staffId);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Grade"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            className="textField"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {gradeIsLoading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={3} md={4} sm={12} xs={12}>
                <Card className={classes.card} sx={{ height: "100%" }}>
                  <Grid container spacing={2} p="24px">
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Select Subject
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Autocomplete
                        options={subjectOptions}
                        loading={subjectIsLoading}
                        getOptionLabel={(option: CustomerOption) =>
                          option.label
                        }
                        value={
                          subjectOptions.find(
                            (opt) =>
                              opt.value === Number(formik.values.subject_id)
                          ) || null
                        }
                        onChange={(_, newValue: CustomerOption | null) => {
                          const staffId = newValue?.value
                            ? String(newValue.value)
                            : "";

                          formik.setFieldValue("subject_id", staffId);
                          setSubjectId(staffId);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Subject"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            className="textField"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {subjectIsLoading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={3} md={4} sm={12} xs={12}>
                <Card className={classes.card} sx={{ height: "100%" }}>
                  <Grid container spacing={2} p="24px">
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Select Staff
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Autocomplete
                        options={filterStaffOptions}
                        loading={assignClassIsLoading}
                        value={
                          filterStaffOptions.find(
                            (opt) =>
                              opt.value === Number(formik.values.staff_id)
                          ) || null
                        }
                        getOptionLabel={(option) => option.label}
                        onChange={(_, newValue) => {
                          const staffId = newValue?.value
                            ? String(newValue.value)
                            : "";
                          formik.setFieldValue("staff_id", staffId);
                          setFilterStaffId(staffId);
                        }}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            {...props}
                            display="flex"
                            alignItems="center"
                            gap={1.5}
                          >
                            {option.image ? (
                              <Avatar
                                src={option.image}
                                sx={{ width: 32, height: 32 }}
                              />
                            ) : (
                              <Avatar sx={{ width: 32, height: 32 }}>
                                {option.label.charAt(0).toUpperCase()}
                              </Avatar>
                            )}
                            <Typography fontSize={14}>
                              {option.label}
                            </Typography>
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Staff"
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: params.inputProps.value
                                ? (() => {
                                    const selected = filterStaffOptions.find(
                                      (opt) =>
                                        opt.value ===
                                        Number(formik.values.staff_id)
                                    );
                                    return selected ? (
                                      <Avatar
                                        src={selected.image || undefined}
                                        sx={{ width: 24, height: 24, mr: 1 }}
                                      >
                                        {!selected.image &&
                                          selected.label
                                            .charAt(0)
                                            .toUpperCase()}
                                      </Avatar>
                                    ) : null;
                                  })()
                                : null,
                              endAdornment: (
                                <>
                                  {assignClassIsLoading ? (
                                    <CircularProgress size={18} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={3} md={4} sm={12} xs={12}>
                <Card className={classes.card} sx={{ height: "100%" }}>
                  <Grid container spacing={2} p="24px">
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Select Location
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Autocomplete
                        options={locationOptions}
                        loading={locationIsLoading}
                        getOptionLabel={(option: CustomerOption) =>
                          option.label
                        }
                        value={
                          locationOptions.find(
                            (opt) =>
                              opt.value === Number(formik.values.location_id)
                          ) || null
                        }
                        onChange={(_, newValue: CustomerOption | null) => {
                          const staffId = newValue?.value
                            ? String(newValue.value)
                            : "";

                          formik.setFieldValue("location_id", staffId);
                          setLocationId(staffId);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Location"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            className="textField"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {locationIsLoading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={3} md={4} sm={12} xs={12}>
                <Card className={classes.card} sx={{ height: "100%" }}>
                  <Grid container spacing={2} p="24px">
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Select Class Mode
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Autocomplete
                        options={studyMoodOptions}
                        getOptionLabel={(option: CustomerOptionString) =>
                          option.label
                        }
                        value={
                          studyMoodOptions.find(
                            (opt) =>
                              opt.value === String(formik.values.class_mode)
                          ) || null
                        }
                        onChange={(
                          _,
                          newValue: CustomerOptionString | null
                        ) => {
                          const staffId = newValue?.value
                            ? String(newValue.value)
                            : "";

                          formik.setFieldValue("class_mode", staffId);
                          setClassMood(staffId);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Class Mode"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            className="textField"
                            InputProps={{
                              ...params.InputProps,
                            }}
                          />
                        )}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={3} md={4} sm={12} xs={12}>
                <Card className={classes.card} sx={{ height: "100%" }}>
                  <Grid container spacing={2} p="24px">
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Select Class Type
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Autocomplete
                        options={classTypeOptions}
                        getOptionLabel={(option: CustomerOptionString) =>
                          option.label
                        }
                        value={
                          classTypeOptions.find(
                            (opt) =>
                              opt.value === String(formik.values.class_type)
                          ) || null
                        }
                        onChange={(
                          _,
                          newValue: CustomerOptionString | null
                        ) => {
                          const staffId = newValue?.value
                            ? String(newValue.value)
                            : "";

                          formik.setFieldValue("class_type", staffId);
                          setClassType(staffId);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Class Type"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            className="textField"
                            InputProps={{
                              ...params.InputProps,
                            }}
                          />
                        )}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={6} md={12} sm={12} xs={12}>
                <Card className={classes.card} sx={{ height: "100%" }}>
                  <Grid container spacing={2} p="24px">
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Select Date
                      </Typography>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          onChange={handleStartDateChange}
                          slotProps={{
                            textField: {
                              placeholder: "From",
                              size: "small",
                              sx: { width: "100%" },
                              error: Boolean(
                                formik.errors.period_based_from_date
                              ),
                              helperText: formik.errors.period_based_from_date,
                              InputProps: {
                                sx: { fontSize: 14 },
                              },
                              InputLabelProps: {
                                sx: { fontSize: 14 },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          onChange={handleEndDateChange}
                          slotProps={{
                            textField: {
                              placeholder: "To",
                              size: "small",
                              sx: { width: "100%" },
                              error: Boolean(
                                formik.errors.period_based_to_date
                              ),
                              helperText: formik.errors.period_based_to_date,
                              InputProps: {
                                sx: { fontSize: 14 },
                              },
                              InputLabelProps: {
                                sx: { fontSize: 14 },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={1}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      className={classes.addButton}
                      onClick={cancelFunction}
                    >
                      Reset
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={3}>
                  {assignClassDataList.map((item: IClassCreateList, index) => {
                    const isSelected = selectedAssignClasses === item.id;
                    const { days, startTime, endTime } =
                      getClassScheduleSummary(item.availability);
                    const staffGet = teamMap.get(item.staff_id);
                    const backgrocolorLocation =
                      locationMap.get(item.location_id)?.location_color ||
                      theme.palette.primary.main;
                    const isEven = index % 2 === 0;
                    return (
                      <Grid item xs={12} sm={12} md={12} lg={12} key={item.id}>
                        <Link
                          to={`/check-staff/classes/list/${item.id}`}
                          className={classes.iconLinkPropNormal}
                        >
                          <Card
                            sx={{
                              height: "100%",
                              borderRadius: setCardBRadius,
                              boxShadow: "none",
                              cursor: "pointer",
                              backgroundColor: isSelected
                                ? backgrocolorLocation
                                : isEven
                                ? "#ffffff"
                                : "#f0f2f1",
                              // color: isSelected ? "#ffffff" : "inherit",
                              "&:hover": {
                                backgroundColor: isSelected
                                  ? backgrocolorLocation
                                  : "#f0f4f8",
                                color: isSelected
                                  ? "#ffffff"
                                  : theme.palette.primary.main,
                              },
                            }}
                          >
                            <Grid
                              container
                              spacing={2}
                              sx={{
                                p: 2,
                              }}
                            >
                              <Grid item xs={12} sm={4} md={1.5} lg={1}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  sx={{ height: "100%" }}
                                  gap={1}
                                >
                                  <CalendarMonthIcon
                                    fontSize="small"
                                    color="primary"
                                    sx={{ fontSize: "24px" }}
                                  />
                                  <Typography variant="body2">
                                    {dayjs(item.created_at).format(
                                      "MM-DD-YYYY"
                                    )}
                                  </Typography>
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={4} md={1.5} lg={1}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={1}
                                  sx={{ height: "100%" }}
                                >
                                  <QueryBuilderIcon
                                    fontSize="small"
                                    color="primary"
                                    sx={{ fontSize: "24px" }}
                                  />
                                  <Typography variant="body2">
                                    {startTime}
                                  </Typography>
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={4} md={1.5} lg={2}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  gap={1}
                                  sx={{ height: "100%" }}
                                >
                                  <PlaceIcon
                                    fontSize="small"
                                    color="primary"
                                    sx={{ fontSize: "24px" }}
                                  />
                                  <Typography variant="body2">
                                    {
                                      locationMap.get(item.location_id)
                                        ?.location_name
                                    }
                                  </Typography>
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={4} md={1.5} lg={2}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  sx={{ height: "100%" }}
                                >
                                  <Typography variant="body2">
                                    {Array.from(
                                      new Set(
                                        item.select_grade_subject_ids
                                          .map((id: number) =>
                                            gradeClassMap.get(id)
                                          )
                                          .filter(Boolean)
                                      )
                                    ).join(", ")}
                                  </Typography>
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={8} md={2} lg={2}>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  sx={{ height: "100%" }}
                                >
                                  <Typography variant="body2">
                                    {Array.from(
                                      new Set(
                                        item.select_grade_subject_ids
                                          .map((id: number) =>
                                            assignClassMap.get(id)
                                          )
                                          .filter(Boolean)
                                      )
                                    ).join(", ")}
                                  </Typography>
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={6} md={2} lg={2}>
                                <Box display="flex" alignItems="center" gap={1}>
                                  {staffGet?.image ? (
                                    <Avatar src={staffGet.image} />
                                  ) : (
                                    <Avatar>
                                      {staffGet?.name ? (
                                        staffGet.name.charAt(0).toUpperCase()
                                      ) : (
                                        <GroupIcon />
                                      )}
                                    </Avatar>
                                  )}
                                  <Typography variant="body2">
                                    {staffGet?.name}
                                  </Typography>
                                </Box>
                              </Grid>

                              <Grid item xs={12} sm={6} md={2} lg={2}>
                                {/* An empty AvatarGroup rendered as blank space, which read as
                                    "a class with sessions" — occurrences are per-student, so a
                                    template with nobody enrolled has generated nothing yet. */}
                                {item.assignStudent.length === 0 && (
                                  <Tooltip
                                    arrow
                                    title="No students assigned. Recurring sessions will be generated after a student is enrolled."
                                  >
                                    <Chip
                                      size="small"
                                      label="No students"
                                      sx={{
                                        height: 22,
                                        fontSize: 11,
                                        fontWeight: 600,
                                        bgcolor: "#fffbeb",
                                        color: "#b45309",
                                        border: "1px solid rgba(180,83,9,0.2)",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                                <AvatarGroup max={4}>
                                  {item.assignStudent.map((student) => {
                                    const studentData = assignStudentMap.get(
                                      student.student_id
                                    );
                                    const studentName = studentData?.name || "";

                                    return (
                                      <Tooltip
                                        key={student.id}
                                        arrow
                                        title={studentName}
                                      >
                                        <Avatar src={studentData?.image}>
                                          {!studentData?.image
                                            ? studentName
                                                .charAt(0)
                                                .toUpperCase()
                                            : null}
                                        </Avatar>
                                      </Tooltip>
                                    );
                                  })}
                                </AvatarGroup>
                              </Grid>
                            </Grid>
                          </Card>
                        </Link>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
          </form>
        </FormikProvider>
      </Grid>
    </Grid>
  );
};

export default Index;
